import { Box, Button, Stack, Typography } from '@mui/material';

// Slack emoji: Clawd, and a Granola turtle. Each comes as a pixel GIF
// (make-gif.py) and a smooth animated SVG (make-svg.py), side by side at
// Slack's sizes, 22px being how big an emoji shows inline in a message.
const EMOJI = [
  { name: 'Pet Claude', slug: 'pet-claude', alt: 'A hand petting Clawd' },
  {
    name: 'Cheeky Claude',
    slug: 'cheeky-claude',
    alt: 'Clawd winking with its tongue out',
  },
  {
    name: "Claude's cooking",
    slug: 'claudes-cooking',
    alt: 'Clawd in a chef hat flipping an egg in a pan',
  },
  {
    name: 'Awkward Granola',
    slug: 'awkward-granola',
    alt: 'A turtle with the Granola logo for a shell, looking awkward',
  },
];
const SIZES = [128, 64, 32, 22];

const STYLES = [
  { label: 'Pixel', src: (slug: string) => `/${slug}.gif`, pixelated: true },
  {
    label: 'Smooth',
    src: (slug: string) => `/vector/emoji/${slug}.svg`,
    pixelated: false,
  },
];

const PetClaude = () => (
  <Stack
    spacing={8}
    sx={{
      minHeight: '100vh',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: 'background.default',
      p: 4,
    }}
  >
    {EMOJI.map(({ name, slug, alt }) => (
      <Stack key={slug} spacing={4} sx={{ alignItems: 'center' }}>
        <Typography variant='h3'>{name}</Typography>
        <Stack direction='row' spacing={8}>
          {STYLES.map(({ label, src, pixelated }) => (
            <Stack key={label} spacing={2} sx={{ alignItems: 'center' }}>
              <Stack
                direction='row'
                spacing={4}
                sx={{ alignItems: 'flex-end' }}
              >
                {SIZES.map((size) => (
                  <Box
                    key={size}
                    component='img'
                    src={src(slug)}
                    alt={alt}
                    sx={{
                      width: size,
                      height: size,
                      imageRendering: pixelated ? 'pixelated' : 'auto',
                    }}
                  />
                ))}
              </Stack>
              <Typography variant='body2'>{label}</Typography>
            </Stack>
          ))}
        </Stack>
        <Button variant='contained' href={`/${slug}.gif`} download>
          Download pixel GIF
        </Button>
      </Stack>
    ))}
  </Stack>
);

export default PetClaude;
